import { FC } from "react";
import { useHistory } from "react-router";

import { Button } from "@livechat/design-system-react-components";

import { useAgentFlag } from "hooks/use-agent-flag";
import { Tip } from "routes/settings/components/Tip";

import { EmailSettingsRoutes } from "../routes";

import { trackTipClosed, trackTipFollowed } from "./analytics";

export const ReplyAddressesTip: FC = () => {
  const history = useHistory();
  const [, setTipClosed] = useAgentFlag("hasClosedReplyAddressesTip");

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleClick = () => {
    trackTipFollowed();
    history.push(EmailSettingsRoutes.Domains);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleClose = () => {
    trackTipClosed();
    setTipClosed(true);
  };

  return (
    <Tip onClose={handleClose} dataTestId="reply-addresses-tip">
      Want to reply to tickets using your domain?{" "}
      <Button onClick={handleClick} kind="link" css={{ fontWeight: "400" }}>
        Add your domain first.
      </Button>
    </Tip>
  );
};
